// The browser's IANA time zone (e.g. "America/Los_Angeles"), sent at signup so creator reminder emails
// go out at 9am local time. undefined lets the backend fall back to its default.
export function getBrowserTimeZone(): string | undefined {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
	} catch {
		return undefined;
	}
}
